'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { Search } from 'lucide-react';
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@/components/ui/command';

// This will be replaced with actual data from the API later
const searchData = [
  {
    title: 'Getting Started',
    href: '/docs',
    description: 'Introduction to the platform',
  },
  {
    title: 'Core Concepts Overview',
    href: '/docs/core-concepts',
    description: 'Overview of the core concepts',
  },
  {
    title: 'Architecture',
    href: '/docs/core-concepts/architecture',
    description: 'Learn about the system architecture',
  },
  {
    title: 'Best Practices',
    href: '/docs/core-concepts/best-practices',
    description: 'Best practices for using the platform',
  },
  {
    title: 'API Introduction',
    href: '/docs/api-reference',
    description: 'Introduction to the API',
  },
  {
    title: 'Authentication',
    href: '/docs/api-reference/authentication',
    description: 'Learn how to authenticate with the API',
  },
  {
    title: 'Contacts API',
    href: '/docs/api-reference/contacts',
    description: 'Learn how to manage contacts using the API',
  },
  {
    title: 'Organizations API',
    href: '/docs/api-reference/organizations',
    description: 'Learn how to list and get organizations using the API',
  },
  {
    title: 'Organization Users API',
    href: '/docs/api-reference/organizations-users',
    description: 'Learn how to manage users within an organization',
  },
  {
    title: 'API Endpoints',
    href: '/docs/api-reference/endpoints',
    description: 'Explore available API endpoints',
  },
  {
    title: 'Quick Start Tutorial',
    href: '/docs/tutorials/quick-start',
    description: 'Get started quickly with this tutorial',
  },
  {
    title: 'Building Your First App',
    href: '/docs/tutorials/first-app',
    description: 'Step-by-step guide to building your first app',
  },
];

export default function DocsSearch() {
  const [open, setOpen] = useState(false);
  const router = useRouter();

  const handleSelect = (href: string) => {
    setOpen(false);
    router.push(href);
  };

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="flex w-full items-center justify-between rounded-md border bg-white px-3 py-2 text-sm text-gray-500 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200"
      >
        <div className="flex items-center">
          <Search className="mr-2 h-4 w-4" />
          <span>Search</span>
        </div>
        <kbd className="flex items-center rounded border border-gray-200 bg-gray-100 px-1.5 font-mono text-xs text-gray-500">
          ⌘K
        </kbd>
      </button>

      <CommandDialog open={open} onOpenChange={setOpen}>
        <CommandInput placeholder="Search documentation..." />
        <CommandList>
          <CommandEmpty>No results found.</CommandEmpty>
          <CommandGroup heading="Documentation">
            {searchData.map((item, index) => (
              <CommandItem
                key={index}
                onSelect={() => handleSelect(item.href)}
              >
                <div className="flex flex-col">
                  <span>{item.title}</span>
                  <span className="text-xs text-gray-500">{item.description}</span>
                </div>
              </CommandItem>
            ))}
          </CommandGroup>
        </CommandList>
      </CommandDialog>
    </>
  );
} 